<template>
    <v-container class="convention-teaser-small">
        <v-row align="center">
            <v-col>
                <typo style="position: relative" name="title-18-medium" with-icon="true">
                    <book v-if="!isChild" />
                    <pin v-if="isChild" />
                    <span class="text">{{ convention.title }}</span>
                </typo>
            </v-col>
            <v-col cols="auto" v-for="variant in variants" :key="variant._uid">
                <convention-teaser-action
                    :selected="isVariantSelected(convention, variant)"
                    :convention="convention"
                    :variant="variant"
                    :hideTooltip="true"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import ConventionTeaserAction from "./ConventionTeaserAction.vue";
import Pin from "src/components/common/icons/Pin.vue";
import Book from "src/components/common/icons/Book.vue";
import { chain } from "lodash";

export default {
    components: { Book, ConventionTeaserAction, Pin },
    props: ["convention", "mode"],
    data() {
        return {
            mouseOverType: null,
        };
    },
    computed: {
        dico() {
            return this.$privateDico.convention.teaser;
        },
        isChild() {
            return this.convention.parentConventionId;
        },
        variants() {
            const rank = {
                syndiquee: 1,
                "non-syndiquee": 2,
                etendue: 3,
                "info-vns": 4,
            };
            const allVariants = chain(this.convention.allVariants)
                .map(v => ({ ...v, rank: rank[v.type] ? rank[v.type] : 0 }))
                .sortBy("rank")
                .value();
            if (this.convention.isHiddenInSearch) {
                const thisVariant = {
                    type: this.convention.type,
                    variantNumber: this.convention.variantNumber,
                };
                return [thisVariant, ...allVariants];
            }
            return allVariants;
        },
    },
    methods: {
        isVariantSelected(convention, variant) {
            return convention.variantNumber == variant.variantNumber;
        },
        changeMouseOverType(type) {
            this.mouseOverType = type;
        },
    },
};
</script>

<style scoped lang="sass">

.convention-teaser-small
    background: $color-secondary
    padding: 5px 0px
    box-shadow: 0 0 2px rgba(0,0,0,0.5)

.typo
    color: white

.book, .pin
    width: 15px
    height: 15px
    position: relative
    top: 0px

.icon
    fill: white

.text
    text-overflow: ellipsis
    overflow: hidden
    white-space: nowrap
    position: absolute
    right: 0
    left: 24px
</style>
